import { NarrativeCommunityListMain } from './components/NarrativeCommunityListMain';
import { NarrativeCommunityListLoader } from './components/NarrativeCommunityListLoader';
import { ErrorBoundary } from '@sentry/react';
import { Alert, AlertAction } from '@simplywallst/ui-core';
import { ComponentProps } from 'react';

type Props = {
  filter: ComponentProps<typeof NarrativeCommunityListMain>['filter'];
  sort: ComponentProps<typeof NarrativeCommunityListMain>['sort'];
  seoTitle: string;
  seoDescription: string;
  seoImageUrl: string;
};

export const NarrativeCommunityList = ({
  filter,
  sort,
  seoTitle,
  seoDescription,
  seoImageUrl,
}: Props) => {
  return (
    <ErrorBoundary
      onError={(error) => console.error('NarrativeCommunityList error', error)}
      fallback={
        <Alert
          styleType="negative"
          actions={
            <AlertAction onClick={() => window.location.reload()}>
              Reload
            </AlertAction>
          }
        >
          Failed to load narratives. Please try again.
        </Alert>
      }
    >
      <NarrativeCommunityListLoader>
        <NarrativeCommunityListMain
          filter={filter}
          sort={sort}
          seoTitle={seoTitle}
          seoDescription={seoDescription}
          seoImageUrl={seoImageUrl}
        />
      </NarrativeCommunityListLoader>
    </ErrorBoundary>
  );
};
